//import { authHeader } from '../_helpers';
//import config from 'react-global-configuration';
//var https = require('https')

export const creditCardService = {
  createSession,
  pinpadCommitFullTransaction
};

async function createSession({ card_id, token, item_list, item_sum, card_full_name, client_url_origin, item_type, payLoadObj, PaymentType }) {
  console.log("createSession");
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', },
    body: JSON.stringify({
      card_id, token, item_list, item_sum, card_full_name,
      client_url_origin: client_url_origin, rest_url: process.env.REACT_APP_REST_URL
      , item_type, payLoadObj, PaymentType
    })
  };
  let response = await fetch(`${process.env.REACT_APP_REST_URL}/payments/createSession`, requestOptions);
  return response.text()
    .then(text => {
      console.log(text);
      const data = text && JSON.parse(text);
      if (!response.ok) {
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }
      return data;
    }).catch((error) => {
      console.error('Error:', error);
      return ({ 'error': true, "message": error.toString() });
    });


};

async function pinpadCommitFullTransaction(payment_obj) {
  console.log("pinpadCommitFullTransaction");
  console.log(payment_obj);
  ;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', },
    body: JSON.stringify({
      ...payment_obj,
      client_url_origin: payment_obj.client_url_origin + (process.env.REACT_APP_TARGET_FOLDER ? ("/" + process.env.REACT_APP_TARGET_FOLDER) : ""), rest_url: process.env.REACT_APP_REST_URL
    })
  };
  let response = await fetch(`${process.env.REACT_APP_REST_URL}/payments/pinpadCommitFullTransaction`, requestOptions);
  return response
    .text()
    .then(text => {
      console.log(text);
      const data = text && JSON.parse(text);
      if (!response.ok) {
        const error = (data && data.message) || response.statusText;
        return ({ 'error': true, "message": error.toString() });
      }
      return data;
    }).catch((error) => {
      console.error('Error:', error);
      return ({ 'error': true, "message": error.toString() });
    });


};
